import type { ReadonlyNonEmptyArray } from '../../../../../../utils'

import { areCybusConnectionsEquals, Capability, type StatusType } from '../../../../../../domain'

import type { PageSubscriptionsTypes, SubscriptionFilterArgs } from '../../../../../../application'

import type { Resource } from '../../../../mappers'
import {
    type AllResourcesRequestConfig,
    BaseStatefulPageResourceSubscriptionStrategy,
    type PageResourceSortableColumnsMap,
    type ServiceResourcesRequestConfig,
} from '../Resource'
import { mapBaseConnection } from './Base'

export class ConnectionsStrategy extends BaseStatefulPageResourceSubscriptionStrategy<'Connection', 'connections'> {
    protected override readonly supportedFilters: (keyof SubscriptionFilterArgs)[] = ['service']

    protected override areEquals = areCybusConnectionsEquals

    protected readonly serviceResourcesRequestConfig: ServiceResourcesRequestConfig<'connections'> = {
        capability: Capability.CONNECTIONS_READ,
        path: '/api/v2/services/+/resources',
        method: 'GET',
    }

    protected override readonly allResourcesRequestConfig: AllResourcesRequestConfig<'connections'> = {
        capability: Capability.CONNECTIONS_READ,
        path: '/api/v2/resources',
        method: 'GET',
    }

    protected override readonly resourceCategories: ReadonlyNonEmptyArray<'Connection'> = ['Connection']

    protected override readonly resourceStatusType = 'connections' as const

    protected override readonly serviceDeviationsType = ['connections', 'connections'] as const

    protected override readonly serverErrorMessage = 'Could not fetch connections'

    protected sortingColumns: PageResourceSortableColumnsMap<'connections'> = {
        agent: 'runnerName',
        cncType: null,
        device: null,
        deviceAddress: null,
        deviceInstance: null,
        host: null,
        id: 'resourceId',
        ipAddress: null,
        name: 'resourceName',
        port: null,
        protocol: 'protocol',
        service: 'serviceId',
        status: null,
    }

    override readonly requiredPermissions = [Capability.CONNECTIONS_READ]

    protected override mapResource (resource: Resource<'Connection'>, status: StatusType): PageSubscriptionsTypes['connections'] {
        return { ...mapBaseConnection(resource), protocol: resource.protocol, status }
    }
}
